<template>
    <!-- 订单支付，首次用net支付流程 第二步 -->
        <div class="container-sheet" >
            <div class="back" @click="closeThird">
                <div class="tag">
                     <!-- <a-icon type="left" />
                    返回 -->
                </div>
               <div class="pirce">
                   <!-- <a-icon type="close" /> -->
                   <i class="el-icon-close"></i>
               </div>
            </div>
            <div class="container-logo">
                <img src="../../assets/apply/zhu.png" alt="">
            </div>
            <div class="container-desc">
                <div class="container-desc-title">
                    We use Plaid to link your blank
                </div>
                <div class="container-sup-desc">
                    <div class="sup-item">
                        <div class="sup-title">
                            <a-icon type="check" />
                            <span class="sup">Secure</span>
                        </div>
                        <div class="sup-item-cont">
                            Encryption helps protect your personal financial data
                        </div>
                    </div>
                     <div class="sup-item">
                        <div class="sup-title">
                            <a-icon type="check" />
                            <span class="sup">Private</span>
                        </div>
                        <div class="sup-item-cont">
                            Encryption helps protect your personal financial dataEncryption helps protect your personal financial data
                            Encryption helps protect your personal financial data
                        </div>
                        <div class="scribe">
                            <div class="scribe_1">By selecting "Continue" your agree to the</div>
                            <div class="scribe_2">Plaid End User Privacy Policy</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns">
                <div class="btn btn100">Continue</div>
            </div>
        </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
       
    }
}
</script>
<style lang="less" scoped>
/deep/ .ant-input{
    border: none;
        &:focus{
        border:none;
        outline: none;
        border-style: none;
        border-right-width:0;
        box-shadow: none;
    }
}
.container-sheet{
    position: fixed;
    padding: 30px;
    width: 600px;
    left: 50%;
    top: 130px;
    margin-left: -300px;
    z-index: 100;
    background: #FFFFFF;
    // background: red;
    border: 1px solid #E1E1E1;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.05);
    opacity: 1;
    border-radius: 5px;
    
    .back{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #262B2F;
        font-size: 20px;
        font-weight: 800;
        color: #000000;
        .tag{
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            color: #262B2F;
        }
    }
  
    .container-logo{
        display: flex;
        justify-content: center;
        margin-top: 20px;
        img{
            width: 130px;
            height: 60px;
        }
    }
    
   
    .container-desc{
        display: flex;
        flex-direction: column;
        .container-desc-title{
            display: flex;
            justify-content: center;
            font-size: 14px;
            font-weight: 800;
            padding: 30px 0;
        }

        .container-sup-desc{
            display: flex;
            flex-direction: column;
            .sup-item{
                display: flex;
                flex-direction: column;
                .sup-title{
                    display: flex;
                    align-items: center;
                    font-weight: 800;
                    .sup{
                        margin-left: 20px;
                    }
                }
                .sup-item-cont{
                    padding: 10px 30px;
                }
                .scribe{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .scribe_1{
                        display: flex;
                        justify-content: center;
                        color: #707070;
                    }
                    .scribe_2{
                        display: flex;
                        justify-content: center;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
   
    
    

    .btns{
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        margin: 25px 0;
        // background: red;
        .btn-desc{
            display: flex;
            justify-content: center;
            font-size: 12px;
            margin: 20px;
        }
        .btn{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            height: 50px;
            color: #FFFFFF;
            background: #262B2F;
            font-size: 14px;
            font-weight: 500;
            border-radius: 4px;
        }
        .btn100{
            width: 100%;
        }
    }
}
@media screen and (max-width: 420px) {
    .bread{
        display: none;
    }
    .container-apply{
        display: flex;
        flex-direction: column;
        // width: 100%;
        // width: 100vw;
        // max-width: 420px;
        width: 100vw;
        margin-top: 100px;
        padding: 0 20px;
        .content-apply{
            display: flex;
            flex-direction: column;
            // width: 100vw;
            .content-left{
                display: flex;
                flex-direction: column;
                overflow: hidden;
                width: 100%;
                padding: 0;
                margin: 0;
                .content-left-up{
                    margin: 0;
                    .info{
                        padding: 0;
                    }
                }
                .content-left-down{
                    margin: 0;
                    margin-top: 20px;
                    // padding: 0 10px;
                    .info{
                        .info-content{
                            display: flex;
                            flex-direction: column;
                            .inp-list{
                                display: flex;
                                flex-direction: column;
                                padding-right: 20px;
                                .inp-item{
                                    display:flex;
                                    width: 100%
                                }
                            };
                        }
                    }
                }
            }
            .content-right{
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0;
                margin: 0;
                margin-top: 20px;
            }
        }
    }

    .container-sheet{
        width: calc(100vw - 20px);
        left: 10px;
        padding: 10px;
        top: 50px;
        margin: 0;
        max-height: 600px;
        overflow-y: scroll;

    }

}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/creditAuditDailog.vue